import {apiRequest} from "../../../components/Utils/SimmsUtils";
import {needAuth} from "../../instance/Instance";
import {getParam} from "../../../components/Utils/Utils";

const getRentalAssetHistories = async (data, success) => {
    return apiRequest(
        () => needAuth.get(`/rental/history/rentalAssets/${data.rentalAssetId}?${getParam(data.pageable)}`),
        success
    );
}

const getRentalRequestHistoriesForRentalAsset = async (data, success) => {
    return apiRequest(
        () => needAuth.get(`/rental/history/rentalAssets/${data.rentalAssetId}/rentalRequest?${getParam(data.pageable)}`),
        success
    );
}

const getRentalRequestHistories = async (data, success) => {
    return apiRequest(
        () => needAuth.get(`/rental/history/rentalRequest/${data.rentalAssetId}?${getParam(data.pageable)}`),
        success
    );
}

export {
    getRentalAssetHistories,
    getRentalRequestHistoriesForRentalAsset,
    getRentalRequestHistories
}